import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { IconButton } from '@mui/material';
import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { HeaderRightButtonContext } from './../MainLayout';
import MenuIcon from '../../components/icons/MenuIcon';

interface TopBarRightButtonsProps {
    onCloseSideBar: () => void;
    onOpenSideBar: () => void;
    sideBarOpen: boolean;
    iconClassName: string;
}

const TopBarRightButtons = (props: TopBarRightButtonsProps) => {
    const {buttonState, setButtonState} = useContext(HeaderRightButtonContext);
    const navigate = useNavigate();
    const location = useLocation();
    // Set when the current detail page was drilled into from the
    // all-tenant (master) view — carries the exact all-tenant URL
    // including its filters (see useMasterListState.drillIntoTenant).
    const navState = location.state as { fromMaster?: string } | null;
    const fromMaster = navState?.fromMaster ?? null;

    const handleCancelButtonClick = () => {
        if (buttonState?.isCancelButton) {
            const previousRoute = buttonState.previousRoute;
            setButtonState({isCancelButton: false, previousRoute: ''});
            props.onCloseSideBar();
            // Detail pages arm the X with a tenant-scoped list route
            // (e.g. /issue-reports). When the user came from the
            // all-tenant view, that would silently drop them into a
            // single tenant's view — return to the all-tenant URL
            // they actually came from instead.
            navigate(fromMaster ?? previousRoute);
        } else {
            props.onCloseSideBar();
        }
    };

    return (
        <React.Fragment>
            {buttonState?.isCancelButton || props.sideBarOpen
                ? (
                    <IconButton onClick={handleCancelButtonClick} className={props.iconClassName} size={'large'}>
                        <CancelOutlinedIcon />
                    </IconButton>
                )
                : (
                    <IconButton onClick={props.onOpenSideBar} className={props.iconClassName}>
                        <MenuIcon />
                    </IconButton>
                )
            }
        </React.Fragment>
    );
};

export default TopBarRightButtons;
